export const COLLECTIONS = {
	LEADS: 'leads',
};

export const SHARE_CONSTANTS = {
	WHATSAPP: 'WhatsApp',
	FACEBOOK: 'Facebook',
};
